import React from 'react';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { em } from 'polished';
import {
  DetailsHeading,
  DetailsLayout,
  EmailLink,
  PhoneLink,
  SecondaryTitle,
} from '../../common';
import { toHref } from '../../../util/helpers';
import { formatAddress } from '../../../util/helpers';
import { appTheme } from '../../../theme';

const OtherContacts = styled.div`
  margin-top: ${em(appTheme.spacing.large)};
`;

const PlaceholderText = styled.p`
  color: ${appTheme.system.title};
  font-style: italic;
`;

const Wrapper = styled.div`
  margin-bottom: 1em;
`;

// Add the other contact here
function Contact(props) {
  const { email, firstName, lastName, primaryPhoneNumber, contactRole } = props;
  return (
    <Wrapper>
      <DetailsHeading>
        {`${firstName} ${lastName} (${contactRole})`}
      </DetailsHeading>
      <PhoneLink tel={primaryPhoneNumber} />
      <EmailLink mailto={email} />
    </Wrapper>
  );
}

const contactPropTypes = {
  email: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  primaryPhoneNumber: PropTypes.string.isRequired,
  contactRole: PropTypes.string,
};

Contact.propTypes = contactPropTypes;

Contact.defaultProps = {};

function PrimaryDoctorDetails({
  addressState,
  city,
  email,
  fax,
  firstName,
  lastName,
  otherContacts,
  phoneExtension,
  practiceName,
  primaryPhoneNumber,
  secondaryStreetAddress,
  streetAddress,
  url,
  zipCode,
  notes,
}) {
  return (
    <DetailsLayout heading={`${firstName} ${lastName}`}>
      <div>{practiceName}</div>
      <div>{streetAddress}</div>
      <div>{secondaryStreetAddress}</div>
      <div>{formatAddress(city, addressState, zipCode)}</div>
      {primaryPhoneNumber && (
        <PhoneLink
          ext={phoneExtension}
          label="Phone"
          tel={primaryPhoneNumber}
        />
      )}
      {fax && <PhoneLink label="Fax" tel={fax} />}
      {email && <EmailLink label="Email" mailto={email} />}
      {url && (
        <div>
          Website/Portal:{' '}
          <a href={toHref(url)} target="_blank">
            {url}
          </a>
        </div>
      )}
      {notes && (
        <div>
          {<span>Notes: </span>}
          {notes}
        </div>
      )}
      <SecondaryTitle>Other Contacts</SecondaryTitle>
      {isEmpty(otherContacts) ? (
        <PlaceholderText>No other contacts have been added.</PlaceholderText>
      ) : (
        <OtherContacts>
          {otherContacts.map(contact => (
            <Contact {...contact} key={contact.id || contact.tempId} />
          ))}
        </OtherContacts>
      )}
    </DetailsLayout>
  );
}

PrimaryDoctorDetails.propTypes = {
  addressState: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  primaryPhoneNumber: PropTypes.string.isRequired,
  streetAddress: PropTypes.string.isRequired,
  zipCode: PropTypes.string.isRequired,
  fax: PropTypes.string,
  notes: PropTypes.string,
  otherContacts: PropTypes.arrayOf(PropTypes.shape(contactPropTypes)),
  phoneExtension: PropTypes.string,
  practiceName: PropTypes.string,
  secondaryStreetAddress: PropTypes.string,
  url: PropTypes.string,
};

PrimaryDoctorDetails.defaultProps = {
  fax: '',
  practiceName: '',
  secondaryStreetAddress: '',
};

export default PrimaryDoctorDetails;



// WEBPACK FOOTER //
// ./src/modules/PrimaryDoctorPage/components/PrimaryDoctorDetails.js